export const userSelector = (state) => state.user;
export const socketSelector = (state) => state.socket;
export const chatSelector = (state) => state.chat;
export const bookkeeperSelector = (state) => state.auth.user;
export const authSelector = (state) => state.auth;
export const expenseSelector = (state) => state.expense;
